/* eslint max-len: 0 */
import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import '../../../../styles/_sports.scss';
import Loading from 'components/common/Loading';
import Error from 'components/common/Error';
import { getTodayMatches } from 'redux/today-matches/todayMatchesSlice';
import translationKeys from 'translations/translationKeys';
import getSortedMatches from 'components/helpers/sortedMatches';
import { selectTodaySport } from 'redux/all-sports/allSportsSLice';
import PropTypes from 'prop-types';
import defaultSportId from 'components/helpers/defaultSport';
import SportItem from '../SportItem';
import defaultImage from '../../../../assets/images/mathys/png/football.png';
import baseUrls from '../../../../config';

const TodayMatches = ({ isMobile }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const imgUrl = baseUrls.BASE_URL_IMG;
  const { msg154 } = translationKeys;

  const {
    todayMatches, successTodayMatches, isLoading, error,
  } = useSelector((store) => store.todayMatches);
  const { allSports, todaySportSelected } = useSelector((store) => store.allSports);
  const { lang } = useSelector((store) => store.language);

  // Fetch whenever the selected sport or language changes
  useEffect(() => {
    const sportId = todaySportSelected?.id || defaultSportId;
    dispatch(getTodayMatches(sportId));
  }, [todaySportSelected, lang, dispatch]);

  const sortedMatches = useMemo(
    () => (successTodayMatches ? getSortedMatches(todayMatches) : []),
    [todayMatches, successTodayMatches],
  );

  const handleSportClick = (sportId) => {
    dispatch(selectTodaySport(sportId));
  };

  return (
    <div className="list-dashboard">
      <div className="content-wrap">
        <div className="tab-content">
          <div className="zone-nav">
            <ul className="sport-list list-inline">
              {allSports?.length > 0 && allSports.map((item) => item && (
                <li
                  key={item.id}
                  className={`nav-item sport list-inline-item${item.id === todaySportSelected?.id ? ' active' : ''}`}
                >
                  <button
                    type="button"
                    className="nav-link"
                    onClick={() => handleSportClick(item.id)}
                  >
                    <img
                      src={imgUrl + item.icon || defaultImage}
                      alt={item.name}
                    />
                    <span>{item.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="tab-content list">
            {isLoading && <Loading />}
            {error && !isLoading && <Error text={t(error)} />}
            {!isLoading && !error && (
              <ul className="match-list">
                {sortedMatches.length > 0
                  ? sortedMatches.map((match) => (
                    <SportItem
                      key={match.id}
                      event={match}
                      isMobile={isMobile}
                      redirect="/dashboard/today-matches"
                    />
                  ))
                  : <Error text={t(msg154)} />}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

TodayMatches.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default TodayMatches;
